import { render, staticRenderFns } from "./Guidelines.vue?vue&type=template&id=1ee35c1a&scoped=true"
import script from "./Guidelines.vue?vue&type=script&lang=js"
export * from "./Guidelines.vue?vue&type=script&lang=js"
import style0 from "./Guidelines.vue?vue&type=style&index=0&id=1ee35c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee35c1a",
  null
  
)

export default component.exports